/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-30 17:30:31
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-04-10 14:41:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelVersionProducts/service.ts
 */
import {
  duplicate_salesChannelProducts,
  request_deleteProducts,
  request_hideProduct,
  request_productList,
  request_productListInit,
  request_showProduct,
} from '@/src/request/salesChannel/product';
import { msg } from '@/src/tools/message';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { defaultPageSize } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { get } from 'lodash';
function useService(uuid: string) {
  const i18n = useI18n();
  const sc = useSalesChannel();
  const decimalPosition = get(sc, 'decimalPosition');

  const getI18n = (str) => i18nGet(i18n, str);
  const [salesChannelProductInfo, setSalesChannelProductInfo] = useState<
    Record<string, any>
  >(default_SalesChannelInfo);
  const [hasBeenConfiged, setConfig] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState('');
  const [products, setProducts] = useState<Array<any>>([]);
  const [tags, setTags] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [visible, setVisible] = useState(false);
  const [productVisible, setProductVisible] = useState(false);
  const [salesChannelSelected, setSalesChannelSelected] = useState([]);
  const [params, setParams] = useState({
    body: {},
    startIndex: 0,
    maxCount: defaultPageSize,
  });

  const { run: runDuplicate } = useRequest(duplicate_salesChannelProducts, {
    manual: true,
    onSuccess: async () => {
      setVisible(false);
      setProductVisible(false);
      setSalesChannelSelected([]);
      message.success(getI18nFromGeneral('general.toast.successfulduplicated'));
      const res = await request_productList(
        uuid,
        params.startIndex,
        params.maxCount,
        { ...params.body, alias: false },
      );
      const total = _.get(res, 'totalCount');
      const products: Array<any> = _.get(res, 'results', []);
      setProducts(products);
      setTotal(total);
    },
  });

  const initalData = () => {
    useEffect(() => {
      setLoading(true);
      request_productListInit(uuid, params.startIndex, params.maxCount, {
        ...params.body,
        listPriceEnabled: true,
        alias: false,
      })
        .then((res) => {
          const total = _.get(res, 'products.totalCount');
          const products: Array<any> = _.get(res, 'products.results', []);
          const tags = _.get(res, 'tags', []) || [];
          const salesChannel = _.get(res, 'salesChannel.name');
          const currency = _.get(res, 'salesChannel.currency');
          const breadcrumb = default_SalesChannelInfo.breadcrumb;
          breadcrumb.splice(2, 1, { url: '', name: salesChannel });
          setConfig(products.length !== 0);
          setProducts(products);
          setTotal(total);
          setLoading(false);
          setCurrency(currency);
          setTags(tags.map((t) => ({ key: t.uuid, name: t.name })));
          setSalesChannelProductInfo({
            salesChannelName: salesChannel,
            breadcrumb,
          });
        })
        .catch((e) => {
          setLoading(false);
        });
    }, []);
  };

  const handleSearchProducts = async (params) => {
    try {
      setParams(params);
      setLoading(true);
      const response = await request_productList(
        uuid,
        params.startIndex,
        params.maxCount,
        { ...params.body, alias: false },
      );
      const total = _.get(response, 'totalCount');
      const products: Array<any> = _.get(response, 'results', []);
      setProducts(products);
      setTotal(total);
    } catch (e) {
      console.log(e, 'err');
    } finally {
      setLoading(false);
    }
  };

  const handleChangeVisiblity = async (visible: boolean, uuid: string) => {
    if (visible) {
      await request_showProduct(uuid);
      msg.success(getI18n('general.successfullyupdated'));
    } else {
      await request_hideProduct(uuid);
      msg.success(getI18n('general.successfullyupdated'));
    }
    await handleSearchProducts(params);
  };

  const handleDeleteProducts = async (ids: Array<string>) => {
    try {
      setLoading(true);
      await request_deleteProducts(ids);
      msg.success(getI18n('general.successfullydeleted'));
      const res = await request_productList(
        uuid,
        params.startIndex,
        params.maxCount,
        { ...params.body, alias: false },
      );
      const total = _.get(res, 'totalCount');
      const products: Array<any> = _.get(res, 'results', []);
      setProducts(products);
      setTotal(total);
    } catch (e) {
      console.log(e, 'err');
    } finally {
      setLoading(false);
    }
  };

  initalData();
  return {
    hasBeenConfiged,
    loading,
    total,
    products,
    tags,
    currency,
    salesChannelProductInfo,
    visible,
    productVisible,
    salesChannelSelected,
    setVisible,
    setProducts,
    setProductVisible,
    handleSearchProducts,
    runDuplicate,
    handleDeleteProducts,
    handleChangeVisiblity,
    setSalesChannelProductInfo,
    setSalesChannelSelected,
    decimalPosition,
  };
}

export default useService;

const default_SalesChannelInfo = {
  breadcrumb: [
    {
      url: '',
      name: getI18nFromGeneral('general.sider.home'),
    },
    {
      url: '/salesChannels',
      name: getI18nFromGeneral('general.sider.salesChannel'),
    },
    {
      url: '',
      name: 'Native Mobile 1',
    },
    {
      url: '',
      name: getI18nFromGeneral('general.sider.products'),
    },
  ],
};
